// #region imports

// --- Angular
import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, OnChanges, ChangeDetectionStrategy } from '@angular/core';

// --- HS Code
import { Constants, GroupModel } from '../../../models';

// #endregion

@Component({
  selector: 'hs-manage-respondents-group-name',
  templateUrl: './manage-respondents-group-name.component.html',
  styleUrls: ['./manage-respondents-group-name.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ManageRespondentsGroupNameComponent implements OnInit, OnChanges {

  @Input() group: GroupModel | null = null;
  @Input() index: number | null = null;

  @Output() groupUpdated = new EventEmitter<GroupModel>();
  @Output() groupDeleted = new EventEmitter<GroupModel>();
  @Output() groupNameControlModeUpdate = new EventEmitter<boolean>();

  charsRemaining = 0;
  isGroupNameEmpty = false;
  isGroupNameEditMode = false;
  maximumNumberOfGroupNameCharacters = Constants.GROUP_NAME_MAXIMUM_LENGTH;

  private isDirty = false;

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['group'] && changes['group'].currentValue) {
      this.charsRemaining = Constants.GROUP_NAME_MAXIMUM_LENGTH - changes['group'].currentValue.groupName.length;
    }
  }

  onUpdate(): void {
    if (this.isDirty && this.group && this.group.groupName) {
      this.isDirty = false;
      this.groupUpdated.emit(this.group);
    }
  }

  onGroupNameChanged(value: string): void {
    this.isDirty = true;
    this.isGroupNameEmpty = value.length === 0;
    if (value.length > Constants.GROUP_NAME_MAXIMUM_LENGTH) {
      value = value.substring(0, Constants.GROUP_NAME_MAXIMUM_LENGTH);
    }
    if (!this.group) return;
    this.group.groupName = value;
    this.charsRemaining = Constants.GROUP_NAME_MAXIMUM_LENGTH - value.length;
  }

  onGroupNameBlur(value: string): void {
    if (value.length === 0) {
      this.isGroupNameEmpty = true;
      if (this.group && !this.group.isSet) {
        this.groupDeleted.emit(this.group);
      }
    }
  }

  onGroupNameControlModeUpdate(isEditMode: boolean) {
    this.isGroupNameEditMode = isEditMode;
    this.groupNameControlModeUpdate.emit(isEditMode);
    if (!isEditMode) {
      this.onUpdate();
    }
  }

}
